export var isValueEqualMultiSelect = function (prevVal, newVal) {
    if (!prevVal && !newVal) {
        return true;
    }
    else if (!prevVal || !newVal || prevVal.length !== newVal.length) {
        return false;
    }
    var notEqualOptions = prevVal.filter(function (option, idx) { return option.value !== newVal[idx].value; });
    return notEqualOptions.length === 0;
};
export var isTextSelected = function (window) {
    var selection = window.getSelection();
    return !!(selection === null || selection === void 0 ? void 0 : selection.toString());
};
//# sourceMappingURL=utils.js.map